<app-modal
  [isOpen]="isOpen"
  [title]="options?.title || 'Alterações não salvas'"
  [size]="'sm'"
  [closable]="true"
  (close)="onClose()">

  <div class="unsaved-changes-content">
    <div class="unsaved-changes-icon">
      <i class="fas fa-exclamation-circle"></i>
    </div>
    <div class="unsaved-changes-message">
      <p>{{ options?.message || '' }}</p>
    </div>
  </div>

  <div slot="footer" class="unsaved-changes-footer">
    <button
      type="button"
      class="btn btn-outline-danger"
      (click)="onDiscard()">
      <i class="fas fa-times"></i>
      {{ options?.discardText || 'Sair sem salvar' }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onSave()">
      <i class="fas fa-save"></i>
      {{ options?.saveText || 'Salvar e sair' }}
    </button>
  </div>
</app-modal>
